module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/main-visual-text-edf9ab339cf6c48bf9c11843ff0854fb.png";